import RpcService from "@/core/services/Rpc/RpcService";
import RpcResponse from "@/core/services/Rpc/RpcResponse";

class CompanyTaxSystemsDAO {

    static async getList(): Promise<RpcResponse> {
        return await RpcService.makeRequest('companies.getTaxSystemsList');
    }
}

export default CompanyTaxSystemsDAO;
